import { arrayToObject } from "@/services/helpers";

export const initProducts = (state, payload) => {
  state.products = arrayToObject(payload, "id");
  state.productsLoaded = true;
};

export const replaceItem = (state, payload) => {
  state.loadedProduct = payload;
};

export const clearLoadedProduct = (state) => {
  state.loadedProduct = {};
  state.quickOpenBatch = {
    id: null,
    product_id: null,
  };
};

export const replaceBatches = (state, payload) => {
  state.loadedProduct.batches = [...payload];
};

export const setQuickOpenBatch = (state, payload) => {
  state.quickOpenBatch.id = payload.batchId;
  state.quickOpenBatch.product_id = payload.productId;
};
